<template>
    <v-app class="background">
        {{showDialogInit}}
        <img class="logoDiba" :src="logoDiba" alt="">
        <TheLanguageSwitcher class="languageSwitch"></TheLanguageSwitcher>

        <div v-show="show" class="welcomePage">
            <v-layout justify-center>
                <h1 class="titleWelcome animated">
                    BENVINGUTS AL
                    <br>
                    JOC DEL PADRÓ!
                </h1>
                <v-flex align-end justify-center row fill-height>
                    <v-layout justify-center align-end class="containerPadroneta">
                        <img :src="padroneta" class="padronetaInici">
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>

        <img :src="imatgeInici" class="imatgeIniciClass">

        <v-layout v-show="!show" justify-center align-center>

            <v-flex xs8 sm4 md4>
                <div class="authenticationCard animated bounceInDown">
                    <v-container>
                        <v-layout justify-center>
                            <div class="titleCard">{{ $t('login')}}</div>
                        </v-layout>
                        <v-layout justify-center>
                            <v-btn round block v-on:click="sigInGoogle" color="orange darken-1"
                                   class="body-2 font-weight-black buttonsAuth">
                                <v-flex>
                                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.6 10.23c0-.82-.1-1.42-.25-2.05H10v3.72h5.5c-.15.96-.74 2.31-2.04 3.22v2.45h3.16c1.89-1.73 2.98-4.3 2.98-7.34z"
                                              fill="#4285F4"/>
                                        <path d="M13.46 15.13c-.83.59-1.96 1-3.46 1-2.64 0-4.88-1.74-5.68-4.15H1.07v2.52C2.72 17.75 6.09 20 10 20c2.7 0 4.96-.89 6.62-2.42l-3.16-2.45z"
                                              fill="#34A853"/>
                                        <path d="M3.99 10c0-.69.12-1.35.32-1.97V5.51H1.07A9.973 9.973 0 0 0 0 10c0 1.61.39 3.14 1.07 4.49l3.24-2.52c-.2-.62-.32-1.28-.32-1.97z"
                                              fill="#FBBC05"/>
                                        <path d="M10 3.88c1.88 0 3.13.81 3.85 1.48l2.84-2.76C14.96.99 12.7 0 10 0 6.09 0 2.72 2.25 1.07 5.51l3.24 2.52C5.12 5.62 7.36 3.88 10 3.88z"
                                              fill="#EA4335"/>
                                    </svg>
                                    Google
                                </v-flex>
                            </v-btn>
                        </v-layout>
                        <v-layout justify-center>
                            <v-btn round block v-on:click="sigInMicrosoft" color="blue darken-1"
                                   class="body-2 font-weight-black buttonsAuth">
                                <v-flex xs12>
                                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <g fill-rule="nonzero" fill="none">
                                            <path fill="#F25022" d="M0 0h9.504v9.504H0z"/>
                                            <path fill="#7FBA00" d="M10.496 0H20v9.504h-9.504z"/>
                                            <path fill="#00A4EF" d="M0 10.496h9.504V20H0z"/>
                                            <path fill="#FFB900" d="M10.496 10.496H20V20h-9.504z"/>
                                        </g>
                                    </svg>
                                    Microsoft
                                </v-flex>
                            </v-btn>
                        </v-layout>
                        <v-layout justify-center>
                            <v-btn round block v-on:click="sigInFacebook" color="blue darken-3"
                                   class="body-2 font-weight-black buttonsAuth">
                                <v-flex xs12>
                                    <img :src="iconFacebook" width="20" height="20">
                                    Facebook
                                </v-flex>
                            </v-btn>
                        </v-layout>
                        <v-layout justify-end>
                            <a class="avisLegalClass" href="http://www.diba.cat/ca/avislegal" target="_blank">{{$t('avisLegal')}}</a>
                        </v-layout>
                    </v-container>
                </div>

            </v-flex>
        </v-layout>
    </v-app>
</template>


<script>

    import {db} from '../firebaseConfig'
    import firebase from 'firebase';


    import 'vuejs-noty/dist/vuejs-noty.css'
    import TheLanguageSwitcher from '../components/TheLanguageSwitcher'


    let usersRef = db.ref('Users');

    import logoDiba from '../img/Marca DB DO negatiu quadrat.png'
    import iconGoogle from '../img/iconGoogle.png'
    import iconMicrosoft from '../img/iconMicrosoft.png'
    import iconFacebook from '../img/iconFacebook.png'
    import logoDefault from '../img/Logo_el_Padronet_celebracio.png'


    import padronet from '../img/Logo_el_Padronet_normal.png'
    import padroneta from '../img/Logo_la_Padroneta_normal.png'
    import imatgeInici from '../img/fondoJocPadro.png'


    export default {
        name: 'Authentication',
        firebase: {
            usersRef
        },
        data() {
            return {
                passwordForgot: '',
                showCardForgotPassword: false,
                show: true,
                logoDiba: logoDiba,
                iconGoogle: iconGoogle,
                iconMicrosoft: iconMicrosoft,
                iconFacebook: iconFacebook,
                logoDefault: logoDefault,
                userData: null,
                uidActualUser: null,
                padronet: padronet,
                padroneta: padroneta,


                //
                numberCorrectAnswers: 0,
                numberFailedAnswers: 0,
                pointsCorrectGame: 0,
                pointsFailedGame: 0,
                counterGames: 0,
                counterWinGames: 0,
                counterLostGames: 0,
                numberCorrectAnswersGame: 0,
                numberFailedAnswersGame: 0,
                score: 0,
                modifyData: null,
                padronetx: null,
                imatgeInici: imatgeInici,
                showWelcomeText: true,
            }

        },
        components: {
            TheLanguageSwitcher
        },
        methods: {
            sigInGoogle() {

                let provider = new firebase.auth.GoogleAuthProvider();
                let this2 = this;

                firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
                    .then(() => {

                        firebase.auth().signInWithPopup(provider).then(() => this.$router.replace('home')
                        ).catch(function (error) {
                            // Handle Errors here.
                            var errorCode = error.code;
                            var errorMessage = error.message;
                            console.log(errorCode + ": " + errorMessage);
                            // The email of the user's account used.
                            var email = error.email;
                            console.log(email);
                            // The firebase.auth.AuthCredential type that was used.

                            var credential = error.credential;
                            console.log(credential)

                        });
                    });
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {

                        let username;
                        let imgUser;
                        let modifyData;
                        let padronetx;
                        let entitat;

                        usersRef.child(user.uid).child('modifyData').on('value', snap => this2.modifyData = snap.val());

                        if (this2.modifyData === true) {
                            usersRef.child(user.uid).child('username')
                                .on('value', snap => username = snap.val());
                            usersRef.child(user.uid).child('imgUser')
                                .on('value', snap => imgUser = snap.val());
                            usersRef.child(user.uid).child('modifyData')
                                .on('value', snap => modifyData = snap.val());
                            usersRef.child(user.uid).child('padronetx')
                                .on('value', snap => padronetx = snap.val());
                            usersRef.child(user.uid).child('entitat')
                                .on('value', snap => entitat = snap.val());

                        } else {
                            username = user.displayName;
                            imgUser = user.photoURL;
                            modifyData = false;
                            padronetx = "1";
                            entitat = "";
                        }

                        this2.verifyVariables(user, this2);

                        db.ref().child('Users').child(user.uid).set({
                            username: username,
                            email: user.email,
                            imgUser: imgUser,
                            numberCorrectAnswers: this2.numberCorrectAnswers,
                            numberFailedAnswers: this2.numberFailedAnswers,
                            pointsCorrectGame: this2.pointsCorrectGame,
                            pointsFailedGame: this2.pointsFailedGame,
                            counterGames: this2.counterGames,
                            counterWinGames: this2.counterWinGames,
                            counterLostGames: this2.counterLostGames,
                            numberCorrectAnswersGame: this2.numberCorrectAnswersGame,
                            numberFailedAnswersGame: this2.numberFailedAnswersGame,
                            score: this2.score,
                            modifyData: modifyData,
                            padronetx: padronetx,
                            entitat: entitat
                        });
                    }
                });

            },
            sigInFacebook() {

                let provider = new firebase.auth.FacebookAuthProvider();
                let this2 = this;

                firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
                    .then(() => {
                        firebase.auth().signInWithPopup(provider).then((user) => this2.userData = user
                        ).catch(function (error) {
                            // Handle Errors here.
                            var errorCode = error.code;
                            var errorMessage = error.message;
                            // console.log(errorCode + ": " + errorMessage);
                        });
                    });
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {

                        let username;
                        let imgUser;
                        let modifyData;
                        let padronetx;
                        let entitat;

                        usersRef.child(user.uid).child('modifyData').on('value', snap => this2.modifyData = snap.val());

                        if (this2.modifyData === true) {
                            usersRef.child(user.uid).child('username')
                                .on('value', snap => username = snap.val());
                            usersRef.child(user.uid).child('imgUser')
                                .on('value', snap => imgUser = snap.val());
                            usersRef.child(user.uid).child('modifyData')
                                .on('value', snap => modifyData = snap.val());
                            usersRef.child(user.uid).child('padronetx')
                                .on('value', snap => padronetx = snap.val());
                            usersRef.child(user.uid).child('entitat')
                                .on('value', snap => entitat = snap.val());


                        } else {
                            username = this2.userData.additionalUserInfo.profile.first_name;
                            imgUser = this2.userData.additionalUserInfo.profile.picture.data.url;
                            modifyData = false;
                            padronetx = "1";
                            entitat = "";
                        }

                        this2.verifyVariables(user, this2);

                        db.ref().child('Users').child(user.uid).set({
                            username: username,
                            email: this2.userData.additionalUserInfo.profile.email,
                            imgUser: imgUser,
                            numberCorrectAnswers: this2.numberCorrectAnswers,
                            numberFailedAnswers: this2.numberFailedAnswers,
                            pointsCorrectGame: this2.pointsCorrectGame,
                            pointsFailedGame: this2.pointsFailedGame,
                            counterGames: this2.counterGames,
                            counterWinGames: this2.counterWinGames,
                            counterLostGames: this2.counterLostGames,
                            numberCorrectAnswersGame: this2.numberCorrectAnswersGame,
                            numberFailedAnswersGame: this2.numberFailedAnswersGame,
                            score: this2.score,
                            modifyData: modifyData,
                            padronetx: padronetx,
                            entitat: entitat
                        });
                    }
                });
            },
            sigInMicrosoft() {

                let provider = new firebase.auth.OAuthProvider('microsoft.com');
                let this2 = this;

                firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
                    .then(() => {
                        firebase.auth().signInWithPopup(provider).then((user) => this2.userData = user
                        ).catch(function (error) {
                            // Handle Errors here.
                            var errorCode = error.code;
                            var errorMessage = error.message;
                            // console.log(errorCode + " ERROR: " + errorMessage);
                        });
                    });
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {

                        let username;
                        let imgUser;
                        let modifyData;
                        let padronetx;
                        let entitat;

                        usersRef.child(user.uid).child('modifyData').on('value', snap => this2.modifyData = snap.val());

                        if (this2.modifyData === true) {
                            usersRef.child(user.uid).child('username')
                                .on('value', snap => username = snap.val());
                            usersRef.child(user.uid).child('imgUser')
                                .on('value', snap => imgUser = snap.val());
                            usersRef.child(user.uid).child('modifyData')
                                .on('value', snap => modifyData = snap.val());
                            usersRef.child(user.uid).child('padronetx')
                                .on('value', snap => padronetx = snap.val());
                            usersRef.child(user.uid).child('entitat')
                                .on('value', snap => entitat = snap.val());


                        } else {
                            let usernameRef = this2.userData.additionalUserInfo.profile.userPrincipalName.split("@");
                            username = usernameRef[0];
                            imgUser = logoDefault;
                            modifyData = false;
                            padronetx = "1";
                            entitat = "";
                        }


                        this2.verifyVariables(user, this2);

                        db.ref().child('Users').child(user.uid).set({
                            username: username,
                            email: this2.userData.additionalUserInfo.profile.userPrincipalName,
                            imgUser: imgUser,
                            numberCorrectAnswers: this2.numberCorrectAnswers,
                            numberFailedAnswers: this2.numberFailedAnswers,
                            pointsCorrectGame: this2.pointsCorrectGame,
                            pointsFailedGame: this2.pointsFailedGame,
                            counterGames: this2.counterGames,
                            counterWinGames: this2.counterWinGames,
                            counterLostGames: this2.counterLostGames,
                            numberCorrectAnswersGame: this2.numberCorrectAnswersGame,
                            numberFailedAnswersGame: this2.numberFailedAnswersGame,
                            score: this2.score,
                            modifyData: modifyData,
                            padronetx: padronetx,
                            entitat: entitat
                        });
                    }
                });

            },
            verifyVariables(user, this2) {

                usersRef.child(user.uid).child('numberCorrectAnswers')
                    .on('value', snap => this2.numberCorrectAnswers = snap.val());

                usersRef.child(user.uid).child('numberFailedAnswers')
                    .on('value', snap => this2.numberFailedAnswers = snap.val());

                usersRef.child(user.uid).child('pointsCorrectGame')
                    .on('value', snap => this2.pointsCorrectGame = snap.val());

                usersRef.child(user.uid).child('pointsFailedGame')
                    .on('value', snap => this2.pointsFailedGame = snap.val());

                usersRef.child(user.uid).child('counterGames')
                    .on('value', snap => this2.counterGames = snap.val());

                usersRef.child(user.uid).child('counterWinGames')
                    .on('value', snap => this2.counterWinGames = snap.val());

                usersRef.child(user.uid).child('counterLostGames')
                    .on('value', snap => this2.counterLostGames = snap.val());

                usersRef.child(user.uid).child('numberCorrectAnswersGame')
                    .on('value', snap => this2.numberCorrectAnswersGame = snap.val());

                usersRef.child(user.uid).child('numberFailedAnswersGame')
                    .on('value', snap => this2.numberFailedAnswersGame = snap.val());

                usersRef.child(user.uid).child('score')
                    .on('value', snap => this2.score = snap.val());


            }
        },
        computed: {
            showDialogInit() {
                setTimeout(() => {
                    this.show = false;
                }, 3000);

            }
        }
    }
</script>

<style lang="scss" scoped>

    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans&display=swap');

    .welcomePage {
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: transparent;
    }


    .languageSwitch {
        z-index: 1;
    }

    .imatgeIniciClass {
        position: absolute;
        height: 100%;
        z-index: 0;
        opacity: 0.4;
        filter: blur(0.5px);

    }

    .imatgeIniciClass0 {
        position: absolute;
        height: 100%;
        z-index: 1;
    }

    .containerPadroneta {
        left: 50%;
        position: absolute;
        top: 80%;
    }

    .padronetaInici {
        position: absolute;
        width: 150px;
        height: 150px;
        z-index: 2;
        opacity: 0.9;
    }

    .padronetInici {
        position: absolute;
        width: 110px;
        height: 110px;
        filter: blur(1px);
        left: 50%;
        top: 50%;
        opacity: 0.8;
        z-index: 2;

    }


    .titleWelcome {
        position: absolute;
        top: 40%;
        display: flex;
        justify-content: center;
        text-align: center;
        font-size: 40px;
        color: white;
        z-index: 2;
        font-family: 'Comic Sans MS', sans-serif;
        text-shadow: 0px 0px 30px gray;
        animation: animateTitleWelcome 1s;
    }

    @keyframes animateTitleWelcome {
        0% {
            transform: scale(5);
        }
        100% {
            transform: scale(1);
        }
    }

    .buttonsAuth {
        color: white;
    }

    .avisLegalClass {
        color: white;
        font-size: 15px;
        margin-right: 10px;
        z-index: 2;
    }

    .logoDiba {
        position: absolute;
        padding: 20px;
        width: 150px;
        z-index: 1;
    }

    .background {
        background-image: linear-gradient(to right top, #2f89fc, #00a0ff, #00b4fd, #00c5f1, #00d3e4, #29d9df, #43dfd9, #5ae5d2, #71e6d8, #86e7dc, #98e8e1, #aae9e4);
    }

    .titleCard {
        font-size: 40px;
        font-family: 'Josefin Sans', sans-serif;
        font-weight: bold;
    }

    .authenticationCard {
        background: #F8B500;
        color: white;
        box-shadow: 0 0 50px dimgray;
        border-radius: 20px;
        font-family: 'Josefin Sans', sans-serif;
    }

    //Adaptar tauler a movil
    @media only screen and (max-width: 720px) {

        .titleWelcome {
            top: 30%;
        }
        .titleCard {
            font-size: 25px;
        }


        .padronetaInici {
            width: 200px;
            height: 200px;
        }
    }

</style>
